import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from './LoadingScreen';

// Pages toujours ouvertes quand l'acces est restreint (company.menu_keys est un
// tableau : utilisateur de la company ou staff limite) — dashboard + pages
// d'index des sections, qui filtrent deja leurs tuiles par menu_keys.
const ALWAYS_ALLOWED = ['/dashboard', '/central', '/rapports', '/controles', '/securite', '/parametres'];

const isPathAllowed = (pathname, menuKeys) => {
  if (ALWAYS_ALLOWED.includes(pathname)) return true;
  // Paiement d'une facture = partie de la Facturation mensuelle.
  if (pathname.startsWith('/paiement/')) return menuKeys.includes('/parametres/facturation');
  return menuKeys.some((key) => pathname === key || pathname.startsWith(`${key}/`));
};

const RequireCompanyAuth = () => {
  const { company, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen />;
  if (!company) return <Navigate to="/login" replace />;

  // URL tapee a la main vers une page retiree -> retour au dashboard (le
  // serveur refuse de toute facon les appels de ces pages pour un utilisateur).
  if (Array.isArray(company.menu_keys) && !isPathAllowed(location.pathname, company.menu_keys)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default RequireCompanyAuth;
